module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./RechargeView.js"));
	}, "RechargeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RechargeView!./src/pages/Shop/Member/Wallet/Recharge/RechargeView.js
// module id = 1578
// module chunks = 418